// @flow
import validate from 'validate.js';

const Util = {};


Util.getEmailError = (email: string): ?string => {
  const constraints = {
    presence: {
      allowEmpty: false,
      message: 'Email cannot be empty.'
    },
    email: {
      message: '%{value} is not a valid email.'
    }
  };
  const errors = validate.single(email, constraints);
  if (errors) {
    return errors[0];
  }
  return undefined;
};


export default Util;
